import { Grid } from '@mui/material';
import { FormControl } from '../../../../../ui/components/pure/form-control/form-control.component';
import { Dropdown } from '../../../../../ui/components/pure/dropdown/dropdown.component';
import { CarrierFormModal, fullWidthStyle, rowGroupStyle } from '../carrier-form-modal.component';
import {
  EditPoliciesActionProps,
  loginMethodOptions,
  registrationPolicyOptions,
  useEditPoliciesAction
} from './edit-policies-action.hook';

export function EditPoliciesModal(props: EditPoliciesActionProps) {
  const { state, handlers, control, handleSubmit } = useEditPoliciesAction(props);

  return (
    <CarrierFormModal
      title={`Edit policies for ${props.carrier.name}`}
      saving={state.saving}
      error={state.error}
      onCancel={handlers.onCancel}
      onSubmit={handleSubmit(handlers.onSubmit)}
    >
      <Grid container spacing={2} style={rowGroupStyle}>
        <Grid size={12}>
          <FormControl
            control={control}
            name="kioskRegistrationPolicy"
            ComponentProps={{
              dropdownVariant: 'floating' as const,
              placeholder: 'Kiosk registration',
              menuItems: registrationPolicyOptions,
              textFieldDesktopWidth: '100%',
              fullWidth: true,
              style: fullWidthStyle
            }}
            Component={Dropdown}
          />
        </Grid>
        <Grid size={12}>
          <FormControl
            control={control}
            name="qrRegistrationPolicy"
            ComponentProps={{
              dropdownVariant: 'floating' as const,
              placeholder: 'QR registration',
              menuItems: registrationPolicyOptions,
              textFieldDesktopWidth: '100%',
              fullWidth: true,
              style: fullWidthStyle
            }}
            Component={Dropdown}
          />
        </Grid>
        <Grid size={12}>
          <FormControl
            control={control}
            name="loginMethod"
            ComponentProps={{
              dropdownVariant: 'floating' as const,
              placeholder: 'Courier login method',
              menuItems: loginMethodOptions,
              textFieldDesktopWidth: '100%',
              fullWidth: true,
              style: fullWidthStyle
            }}
            Component={Dropdown}
          />
        </Grid>
      </Grid>
    </CarrierFormModal>
  );
}
